import React, { useEffect, useRef, useState } from 'react';
import QrReader from "react-qr-reader";
import { CheckTicketContext } from './CheckTicketPopup';
import Scanner from '../barcodescanner/Scanner';
import Result from '../barcodescanner/Result';
import MessageInfo from '../common/MessageInfo';
import { vibrate } from '../utils/sport-effects';
import { labels } from '../data/labels';
import { getBaseURL } from '../data/utils/getBaseURL';
import { getCheckbetPage } from '../data/utils/getCheckbetPage';
import { REGEX_URL } from '../data/utils';
import { systemCode, xs_languageCode } from '..';
import { iOS, isSafari } from '../data/util/browserDetector';

function CheckTicketQRCodeScanner() {
    const checkTicketContext = React.useContext(CheckTicketContext);
    const [scanning, setScanning] = useState(false);
    const [results, setResults] = useState([]);
    const [isError,setIsError] = useState(false);
    const scannerRef = useRef(null);
    const ios = isSafari || iOS();

    function handleScan(data) {
        if (data) {
            vibrate();
            if(REGEX_URL.test(data)){
                checkTicketContext.setCheckbetUrl(data);
            }else{
                if(ios){
                    checkTicketContext.setTicketId(data);
                }else{
                    const baseURL = getBaseURL();
                    const checkbetPage = getCheckbetPage(true);
                    const ticketUrl = `${baseURL.replace('xsport_desktop', 'xsport_mobile')}${checkbetPage}?ticket=${data}&system_code=${systemCode}&language=${xs_languageCode}`;
                    checkTicketContext.setCheckbetUrl(ticketUrl);
                    //checkTicketContext.setTicketId(data);
                }
            }
        }
      }
       function handleError(err) {
          setIsError(true);
          //alert(err);
          console.error(err)
    }

    function handleLoad(object){
    }

    useEffect(() => {
        setScanning(checkTicketContext.scannerStarted);
    }, []);

    const constraints = {facingMode: "environment", width:{exact: 900}, height:{exact: 480}};

    try {
        return (
            <>{isError?
               <MessageInfo message={labels['check_ticket.not_supported']} />
               :scanning && 
                <div>
                <QrReader
                    delay={300}
                    onError={handleError}
                    onScan={handleScan}
                    onLoad={handleLoad}
                    constraints={constraints}
                ></QrReader>
               </div>
            }
            </>
          );
    }catch(err){
        return <MessageInfo message={labels['check_ticket.not_supported']} />
    }
   
}

export default CheckTicketQRCodeScanner;